module.exports = __webpack_public_path__ + "static/media/medical_research2.8cad16d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medical_research2.svg
// module id = 91
// module chunks = 0